import React from 'react';
import Conditional from '../../common/conditional';
import ListGroupItem from './list-group-item';

import { SelectOption } from '../../../utils/models';

import classNames from './style.module.scss';

interface ListGroupProps {
	data: SelectOption[];
	onRemove?: (listItem: SelectOption) => void;
	onEditItem?: (listItem: SelectOption) => void;
}

const ListGroup: React.FC<ListGroupProps> = (props) => {
	return (
		<Conditional isVisible={props.data.length > 0}>
			<ul className={classNames['list-option']}>
				{props.data.map((item: SelectOption, index: number) => (
					<ListGroupItem key={index} item={item} onEditItem={props.onEditItem} onRemove={props.onRemove} />
				))}
			</ul>
		</Conditional>
	);
};

export default ListGroup;
